import objectFitImages from 'object-fit-images';

window.addEventListener('load', (e) => {
	objectFitImages( null, {
		watchMQ: true
	});
});